import { connect } from "react-redux";
import Overview from "./Overview";
import {
  getProgramDetails,
  deleteProgramsRequest,
  updateProgramsRequest,
  ProgramStatusReportRequest,
  ProgramClearReportRequest,
  ProgramConfirmWsrReport,
  getProgressTracker,
} from "../../../store/actions/programs.actions";
import {
  overviewLoader,
  program,
  programBudgetSummary as budgetSummary,
  programProgressSummary as progressSummary,
  programLoading,
  programReport,
  programReportLoading,
  programConfirmedReport,
  programConfirmReportLoading,
} from "../../../store/selectors/programs.selector";

const mapDispatchToProps = {
  getProgramDetails,
  deleteProgramsRequest,
  updateProgramsRequest,
  ProgramStatusReportRequest,
  ProgramClearReportRequest,
  ProgramConfirmWsrReport,
  getProgressTracker,
};

const mapStateToProps = (state) => {
  const programData = program(state);
  const programBudgetSummary = budgetSummary(state);
  const programProgressSummary = progressSummary(state);
  const loading = programLoading(state);
  const programOverviewLoading = overviewLoader(state);
  const getProgramReport = programReport(state);
  const getProgramReportLoading = programReportLoading(state);
  const getProgramConfirmedReport = programConfirmedReport(state);
  const getProgramConfirmReportLoading = programConfirmReportLoading(state);
  return {
    programData,
    programBudgetSummary,
    programProgressSummary,
    loading,
    programOverviewLoading,
    getProgramReport,
    getProgramReportLoading,
    getProgramConfirmedReport,
    getProgramConfirmReportLoading,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Overview);
